import { api, getBlobUrl, postForBlobUrl } from './client';

export interface InvoiceTemplateDto {
  accentColor: string | null;
  preset: string;
  showUnitColumn: boolean;
  emphasizePaymentDetails: boolean;
  footerText: string;
  hasLogo: boolean;
}

export interface SaveInvoiceTemplateRequest {
  accentColor?: string | null;
  preset?: string;
  showUnitColumn: boolean;
  emphasizePaymentDetails: boolean;
  footerText?: string;
}

export const invoiceTemplatesApi = {
  get: () => api.get<InvoiceTemplateDto>('/invoices/template'),

  save: (data: SaveInvoiceTemplateRequest) =>
    api.put<InvoiceTemplateDto>('/invoices/template', data),

  uploadLogo: (file: File) => {
    const form = new FormData();
    form.append('file', file);
    return api.upload<InvoiceTemplateDto>('/invoices/template/logo', form);
  },

  removeLogo: () => api.delete<InvoiceTemplateDto>('/invoices/template/logo'),

  /** Renders a sample-invoice PDF with the stored template; returns an object URL. */
  previewUrl: () => postForBlobUrl('/invoices/template/preview'),

  /** The stored logo image as an object URL (for the builder canvas). */
  logoUrl: () => getBlobUrl('/invoices/template/logo'),
};
